"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInfo = void 0;
var UserInfo = /** @class */ (function () {
    function UserInfo(sub, oid, userInfo) {
        var fullName;
        if (userInfo.given_name || userInfo.family_name) {
            fullName = userInfo.given_name
                ? userInfo.given_name
                : '' + ' ' + userInfo.family_name
                    ? userInfo.family_name
                    : '';
        }
        this.sub = sub;
        this.oid = oid;
        this.name = userInfo.name ? userInfo.name : fullName;
        this.family_name = userInfo.family_name;
        this.given_name = userInfo.given_name;
        this.middle_name = userInfo.middle_name;
        this.nickname = userInfo.nickname;
        this.preferred_username = userInfo.preferred_username;
        //this.userInfo = userInfo.userInfo;
        this.profile = userInfo.profile;
        this.picture = userInfo.picture;
        this.website = userInfo.website;
        this.gender = userInfo.gender;
        this.birthdate = userInfo.birthdate;
        this.zoneinfo = userInfo.zoneinfo;
        this.locale = userInfo.locale;
        this.updated_at = userInfo.updated_at;
        this.email = userInfo.email;
        this.email_verified = userInfo.email_verified;
        this.phone_number = userInfo.phone_number;
        this.phone_number_verified = userInfo.phone_number_verified;
        this.formatted = userInfo.formatted;
        this.street_address = userInfo.street_address;
        this.locality = userInfo.locality;
        this.region = userInfo.region;
        this.postal_code = userInfo.postal_code;
        this.country = userInfo.country;
        this.role = userInfo.role;
        this.customAttributes = userInfo.customAttributes
            ? userInfo.customAttributes
            : {};
    }
    return UserInfo;
}());
exports.UserInfo = UserInfo;
//# sourceMappingURL=user.info.js.map